import { Action } from '@ngrx/store';
import { ActionTypes } from '../../core/models/actionTypes';
import { SessionUser } from '../models/session-user';

export const SessionUserAction = (sessionUser: SessionUser) => {
  localStorage.removeItem('user');
  localStorage.setItem('user', JSON.stringify(sessionUser));
  return <Action>{ type: ActionTypes.SessionUser, payload: sessionUser };
};
